/**
 * @file 银行卡列表页
 * @date 2020/07/29
 */

import React, {Component} from 'react';
import NavBarComponent from '../../component/common/NavBarComponent';
import {NavBar, WingBlank, Button, Icon} from 'antd-mobile';
import {parseStateToSearch} from '../../util/util.js';
import {Http} from '../../api/index';
import './index.scss';

class CardList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }

    componentDidMount() {
        this.getCardList();
    }

    getCardList() {
        Http.post({url: '/api/payment/bank/v1/banklist/get.json'}).then(res => {
            this.setState({
                list: res.data || []
            });
        });
    }

    addCard() {
        this.props.history.push({
            pathname: '/bindCard'
        });
    }

    render() {
        let {list} = this.state;
        return (
            <div id="card-list" className="page">
                <NavBarComponent>
                    <NavBar
                        icon={<Icon type="left" color='#333' />}
                        onLeftClick={() => {this.props.history.goBack();}}
                        mode='light'>
                        信用卡
                    </NavBar>
                </NavBarComponent>
                <div className="list-wrap">
                    {
                        list.length === 0 ? null
                        : list.map(item => {
                            return (
                                <div
                                    key={item.bankName}
                                    className="page-section list-item">
                                    <span>{item.bankName}</span>
                                    <span>{item.bankCardNo}</span>
                                </div>
                            );
                        })
                    }
                </div>
                <WingBlank>
                    <div className="page-section">
                        <Button
                            type="warning"
                            onClick={e => {this.addCard(e);}}>
                            新增信用卡
                        </Button>
                    </div>
                </WingBlank>
            </div>
        );
    }
}

export default CardList;